import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <>
      {/* Scalloped wave — white → yellow */}
      <div style={{ lineHeight: 0, background: '#fff' }}>
        <svg viewBox="0 0 1200 70" preserveAspectRatio="none" style={{ width: '100%', height: '70px', display: 'block' }}>
          <path
            d="M0,35 C100,70 200,0 300,35 C400,70 500,0 600,35 C700,70 800,0 900,35 C1000,70 1100,0 1200,35 L1200,70 L0,70 Z"
            fill="#FFD600"
          />
        </svg>
      </div>

      <footer style={{ background: '#FFD600', color: '#1a2e3d' }} className="py-5">
        <div className="container">
          <div className="row g-4 align-items-center mb-4">
            <div className="col-md-6">
              <div className="d-flex align-items-center gap-2 mb-2">
                <span style={{ fontSize: '1.8rem' }}>🌏</span>
                <span className="fw-bold fs-4" style={{ fontFamily: 'Poppins, sans-serif', color: '#1a2e3d' }}>
                  Glocal Festival
                </span>
              </div>
              <p className="mb-0" style={{ color: 'rgba(26,46,61,.65)', fontSize: '.9rem' }}>
                {t('footer.tagline')}
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="d-flex justify-content-md-end gap-3 mb-2">
                {['instagram', 'facebook', 'youtube'].map(s => (
                  <a
                    key={s}
                    href="#!"
                    style={{
                      color: '#1a2e3d',
                      fontSize: '1.4rem',
                      opacity: 0.7,
                      transition: 'opacity .2s',
                      textDecoration: 'none',
                    }}
                    onMouseEnter={e => e.currentTarget.style.opacity = '1'}
                    onMouseLeave={e => e.currentTarget.style.opacity = '0.7'}
                  >
                    <i className={`bi bi-${s}`} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <hr style={{ borderColor: 'rgba(26,46,61,.2)', margin: '0 0 20px' }} />

          <div className="row align-items-center g-2">
            <div className="col-md-6">
              <p className="mb-0 small" style={{ color: 'rgba(26,46,61,.6)' }}>
                🏝️ Made in Okinawa by{' '}
                <span style={{ color: '#1a2e3d', fontWeight: 700 }}>Ryukyu GLOCAL Tech</span>
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <p className="mb-0 small" style={{ color: 'rgba(26,46,61,.6)' }}>
                Copyright &copy; {year}{' '}
                <span style={{ color: '#1a2e3d', fontWeight: 700 }}>株式会社琉球GLOCAL</span>
                {' '}All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
